import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { getPriceRowFromPrice, NightlyPrice, NightlyPricesColumns } from '../../../policies/models/NightlyPrices';
import { PolicyPrice } from '../../../policies/models/Policy';
import { CurrenciesService } from '../../../currencies/services/currencies.service';
import { PropertyApiService } from '../../../properties/services/property.api.service';
import { Logger } from '../../../../infrastructure/logging/logger';

@Component({
    selector: 'app-price-range-modal',
    templateUrl: './price-range-modal.component.html',
    styleUrls: ['./price-range-modal.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      MatTableModule,
      MatIcon,
      MatButtonModule
    ]
})
export class PriceRangeModalComponent implements OnInit {

    dataSource: any;
    extraNightPrice: any;
    displayedColumnNames: string[] = [];
    displayedColumns = NightlyPricesColumns;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PriceRangeModalComponent>,
        private propertiesService: PropertyApiService,
        private currenciesService: CurrenciesService,
        private logService: Logger
    ) { }

    ngOnInit(): void {
        this.fetchPolicyPriceDetail();
        this.initTableColumns();
    }

    async fetchPolicyPriceDetail() {
        let policyPriceId: string;
        if (this.data.row === undefined) {
            policyPriceId = this.data.policyPriceId;
        } else {
            policyPriceId = this.data.row.policyPriceId;
        }
        const response = await this.propertiesService.getPropertyPolicyPriceDetail(policyPriceId);

        if (response === null) {
            this.logService.handleError('', `Could not retrieve policy price range for PolicyPriceID: [${this.data.row.policyPriceId}]`, `Could not retrieve policy price range for PolicyPriceID: [${this.data.row.policyPriceId}]`);
            return;
        }
        this.populatePolicies(response);
    }

    populatePolicies(policyPrice: PolicyPrice) {
        this.dataSource = new MatTableDataSource(this.getPriceRangeRows(policyPrice));
        this.extraNightPrice = this.currenciesService.prependCurrencySymbol(policyPrice.currency, `${policyPrice.extra_night_price}`);
    }

    async populatePriceRateNightRanges(priceRate: any) {
        this.dataSource = new MatTableDataSource(this.getPriceRangeRows(priceRate));
        this.extraNightPrice = this.currenciesService.prependCurrencySymbol(priceRate.currency, `${priceRate.extra_night_price}`);
    }

    getPriceRangeRows(policyPrice: PolicyPrice) {
        return policyPrice.night_ranges.map((price: NightlyPrice) => {
            return getPriceRowFromPrice(price, policyPrice.currency, this.currenciesService);
        });
    }

    initTableColumns(): void {
        this.displayedColumnNames = NightlyPricesColumns.map(c => c.column);
    }

    onCloseClick() {
        this.dialogRef.close();
    }
}